import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthorizeGuardAllowService } from 'src/app/services/authorize-guard-allow.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-olvido-contrasena',
  templateUrl: './olvido-contrasena.component.html',
  styleUrls: ['./olvido-contrasena.component.css']
})
export class OlvidoContrasenaComponent {

  emailError = new FormControl('', [Validators.required, Validators.email]);
  errorMessage: string = "";
  errorVisible: boolean = false;

  signin: FormGroup;

  constructor(public userService : UserService, public router: Router, private formBuilder: FormBuilder, private authorizeGuard: AuthorizeGuardAllowService){
    this.signin = this.formBuilder.group({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  get emailInput() { 
    return this.signin.get('email'); 
  }

  continuar() {
    this.errorVisible = false;
    //Comprobar que el email exista y sea único
      //Enviar mensaje con código al email
    //Devolver respuesta error o success
    console.log(this.emailInput?.value);

    //Solo se puede acceder a este componente a través del botón continuar.
    this.authorizeGuard.allowAccess();
    this.router.navigate(['/cambiar-contraseña']);
    console.log(this.authorizeGuard.allowAccess);
  }

  getErrorMessageEmail() {
    if (this.emailError.hasError('required')) {
      return 'Debes ingresar un email valido';
    }
    return this.emailError.hasError('emailErro') ? 'Not a valid email' : '';
  }

}
